import { Route, Routes } from "react-router-dom";
import LectureAddPage from "./LectureAddPage";
import LectureListPage from "./LectureListPage";

const LecturePage = () => {
  return (
    <>
      <Routes>
        <Route index element={<LectureListPage />} />
        <Route path="add" element={<LectureAddPage />} />
        <Route path="update/:lecture_id" element={<LectureAddPage />} />
      </Routes>
    </>
  );
};

export default LecturePage;
